import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { RentalPricerStore } from '../stores/rentalPricerStore';

export const useRentalPricerStore = () => useContext<{
  rentalPricerStore: RentalPricerStore
}>(StoreContext);
